export function BurgerMenuSVG() {
  return (
    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 1H0" stroke="white" />
      <path d="M16 9H0" stroke="white" />
    </svg>
  )
}
